import { Anchor, Box, Flex, Group, Image, Stack } from '@mantine/core';
import { Footer, HeroBackground, Section, SectionText, SectionTitle } from 'components';
import { APP_STORE_IMG, APP_STORE_LINK, GOOGLE_PLAY_IMG, GOOGLE_PLAY_LINK, MOBILE_APP_IMG_SR, MOBILE_APP_IMG_DE, MOBILE_APP_IMG_EN, NUMBER_OF_MOBILE_APP_BENEFITS, TABLE_IMG } from 'constants/app';

import { useTranslation } from 'react-i18next';
import classes from './index.module.css';

const MobileAppPage = () => {
    const { t, i18n } = useTranslation();

    const currentLang = i18n.language;

    const mobileAppImages: Record<string, string> = {
        sr: MOBILE_APP_IMG_SR,
        de: MOBILE_APP_IMG_DE,
        en: MOBILE_APP_IMG_EN,
      };

    const mobileAppImage = mobileAppImages[currentLang] || MOBILE_APP_IMG_DE;

    return (
        <>
            <HeroBackground image={TABLE_IMG}>
                <Section hero={true}>
                    <Flex gap={{ base: 0, md: 50 }} direction={{ base: 'column', md: 'row' }} className={classes.wrapper}>
                        <Flex className={classes.infoImageBox} direction={{ base: 'column', md: 'row' }}>
                            <Stack gap={30} className={classes.info}>
                                <SectionTitle title={t('mobile_app.hero.title')} variant='light' />
                                <SectionText text={t('mobile_app.hero.descriptions.0')} />
                                <SectionText text={t('mobile_app.hero.descriptions.1')} />
                                <Group justify='space-between'>
                                    <Anchor href={GOOGLE_PLAY_LINK} target='_blank'>
                                        <Image className={classes.logos} src={GOOGLE_PLAY_IMG} />
                                    </Anchor>
                                    <Anchor href={APP_STORE_LINK} target='_blank'>
                                        <Image className={classes.logos} src={APP_STORE_IMG} />
                                    </Anchor>
                                </Group>
                            </Stack>
                            <Box className={classes.imageBox}>
                                <Image src={mobileAppImage} />
                            </Box>
                        </Flex>
                        <Stack gap={10} className={classes.benefits}>
                            {Array(NUMBER_OF_MOBILE_APP_BENEFITS).fill(null).map((_, index) => (
                                <SectionText key={index} text={t(`mobile_app.hero.benefits.${index}`)} />
                            ))}
                        </Stack>
                    </Flex>
                </Section>
            </HeroBackground>
            {/* <Section title={t('mobile_app.help.title')} titleVariant='dark'>
                <Box className={classes.videoWrapper} ta='center'>
                    <iframe
                        src='https://www.youtube.com/embed/0oZIiP7Ips0?si=wq0HWEwWxvJrmegZ'
                        title='YouTube video player'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowFullScreen>
                    </iframe>
                </Box>
            </Section> */}
            <Footer />
        </>
    )
}

export default MobileAppPage;